module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e54636902d4b5c31f52aa582c0bac0f0.gif";